import { createSlice } from '@reduxjs/toolkit';

import { projectInit } from 'actions';

export interface DebugSelectionPanelState {
  isOpen: boolean;
}

const initialState: DebugSelectionPanelState = {
  isOpen: false,
};

const debugSelectionPanelSlice = createSlice({
  name: 'debugSelectionPanel',
  initialState,
  reducers: {
    openDebugSelectionPanel: state => {
      state.isOpen = true;
    },
    closeDebugSelectionPanel: state => {
      state.isOpen = false;
    },
  },
  extraReducers: builder => {
    builder.addCase(projectInit, () => ({ ...initialState }));
  },
});

export const { openDebugSelectionPanel, closeDebugSelectionPanel } =
  debugSelectionPanelSlice.actions;

export default debugSelectionPanelSlice.reducer;
